import { ApplicationConfig, importProvidersFrom, inject, Injector, LOCALE_ID, provideAppInitializer, runInInjectionContext } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTranslateService, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { AddictionAuthModule, AuthService } from 'addiction-auth';
import { environment } from 'src/environments/environment';
import { authConfig, authModuleConfig } from './auth/auth.config';
import { authServiceInit } from './auth/auth-initializer';
import { SugarAuthService } from './auth/sugar-auth.service';
import { NavigationService } from './navigation.service';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthJWTInterceptor } from './interceptors/auth-jwt.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { provideToastr } from 'ngx-toastr';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { firstValueFrom } from 'rxjs';

registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes),
		provideHttpClient(withInterceptors([AuthJWTInterceptor, ErrorInterceptor])),
		provideAnimations(),
		provideLottieOptions({
			player: () => player,
		}),
		{ provide: LOCALE_ID, useValue: 'it' },
		provideTranslateService({
			defaultLanguage: 'it-IT',
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient],
			},
		}),
		importProvidersFrom(AddictionAuthModule.forRoot(environment as unknown as Record<string, unknown>, authConfig, authModuleConfig)),
		provideAppInitializer(() => {
			const injector = inject(Injector);
			const authService = inject(AuthService);
			const sugarAuth = inject(SugarAuthService);
			return runInInjectionContext(injector, () => {
				const navigationService = inject(NavigationService);
				return authServiceInit(authService, sugarAuth)();
			});
		}),
		//le guard della prima navigazione (es. ingresso diretto in quotation/new) mostrano toast tradotti:
		//senza aspettare il JSON delle traduzioni, instant() restituirebbe la chiave
		provideAppInitializer(() => firstValueFrom(inject(TranslateService).use('it-IT'))),
		provideToastr({ positionClass: 'toast-bottom-center' }),
		{ provide: 'environment', useValue: environment },
	],
};

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
